export const c_tooltip_MaxWidth = {
  "name": "--pf-v6-c-tooltip--MaxWidth",
  "value": "18.75rem",
  "var": "var(--pf-v6-c-tooltip--MaxWidth)"
};
export default c_tooltip_MaxWidth;